import { EnhancementDay } from '../../models/enhancement'

const areObjectsEqual = (obj1: EnhancementDay, obj2: EnhancementDay) =>
  obj1.checked === obj2.checked &&
  obj1.hours === obj2.hours &&
  obj1.day === obj2.day &&
  obj1.calculationCode === obj2.calculationCode

export const hasDaysChanged = (days: EnhancementDay[], updatedDays: EnhancementDay[]) =>
  !days.every((day, index) => areObjectsEqual(day, updatedDays[index]))
